import liveCourseService from '@/services/liveCourse.js';

const state = {
  liveCourseUnitCardCount: 0,
};

const getters = {
  liveCourseUnitCardCount(state) {
    return state.liveCourseUnitCardCount || 0;
  },
};

const actions = {
  async getLiveCourseUnitCardCount({commit}) {
    try {
      const result = await liveCourseService.getLiveCourseUnitCardCount();
      commit('setLiveCourseUnitCardCount', result);
      return result;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
};

const mutations = {
  setLiveCourseUnitCardCount(state, data) {
    state.liveCourseUnitCardCount = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
